import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getQuestionWithFilter as asyncGetQuestionWithFilter,
  getQuestionWithIDS as asyncgetQuestionWithId,
  updateQuestion as asyncUpdateQuestionStatus,
  createQuestion as asyncCreateQuestion,
  deleteQuestion as asyncDeleteQuestion,
  bulkDeleteQuestion as asyncBulkDeleteQuestion,
  getQuestionPage as asyncGetQuestionPage, // Fixed typo in the function name
} from "../../helpers/apis";
import { toast } from 'react-toastify';
import { showToast } from "../toast/reducer";

// Thunk for fetching questions with filter
export const getQuestionWithFilter = createAsyncThunk(
  "getQuestionWithFilter",
  async (req, thunkAPI) => {
    try {
      const response = await asyncGetQuestionWithFilter(req);
      console.log("Fetched questions:", response); // log here to check response
      return response; // Ensure the response structure matches the expected format
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error fetching questions" }));
      throw error;
    }
  }
);

// Thunk for fetching paginated questions
export const getQuestionPage = createAsyncThunk(
  "getQuestionPage",
  async (req, thunkAPI) => {
    try {
      const { currentPage = 1, perPage = 20, ...filters } = req; // Ensure pagination is included
      const response = await asyncGetQuestionPage({
        ...filters,
        currentPage,
        perPage,
      });
      console.log("Fetched question results thunk:", response);
      return response;
    } catch (error) {
      thunkAPI.dispatch(
        showToast({ type: "error", msg: error?.msg || "Error fetching question results" })
      );
      throw error;
    }
  }
);

// Thunk for creating a question
export const createQuestion = createAsyncThunk(
  "createQuestion",
  async (data, thunkAPI) => {
    console.log(data);
    try {
      const response = await asyncCreateQuestion(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response?.msg || "Question created successfully!" }));
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error creating question" }));
      throw error;
    }
  }
);

// Thunk for updating a question
export const updateQuestion = createAsyncThunk(
  "updateQuestion",
  async (data, thunkAPI) => {
    try {
      const response = await asyncUpdateQuestionStatus(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response?.msg || "Category updated successfully" }));
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error updating status" }));
      throw error;
    }
  }
);

// Thunk for fetching a single question by ID
export const getQuestionWithId = createAsyncThunk(
  "getQuestionWithId",
  async (id, thunkAPI) => {
    try {
      const response = await asyncgetQuestionWithId(id);
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error fetching question by ID" }));
      throw error;
    }
  }
);

// Thunk for deleting a question
export const deleteQuestion = createAsyncThunk(
  "deleteQuestion",
  async (req, thunkAPI) => {
    try {
      const response = await asyncDeleteQuestion(req);
      // toast.success("Question deleted successfully!");
      thunkAPI.dispatch(showToast({ type: "success", msg: response?.msg || "Question deleted successfully!" }));
      return response;
    } catch (error) {
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error deleting question" }));
      throw error;
    }
  }
);

// Thunk for bulk deleting questions
export const bulkDeleteQuestion = createAsyncThunk(
  "bulkDeleteQuestion",
  async (data, thunkAPI) => {
    try {
      const response = await asyncBulkDeleteQuestion(data);
      thunkAPI.dispatch(showToast({ type: "success", msg: response?.msg || "Questions deleted successfully!" }));
      return data.questionIds;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(showToast({ type: "error", msg: error?.msg || "Error bulk deleting questions" }));
      throw error;
    }
  }
);
